// Pads any image onto a transparent square canvas, so a wide logo can still be
// framed whole by the 1:1 crop. Rejects when the browser cannot decode the file
// (a corrupt or mislabelled PNG/JPG) or the canvas yields no image, so the
// caller can say so instead of the upload silently doing nothing.
export function makeImageSquare(imageUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("No 2d context"));
        return;
      }
      const size = Math.max(img.width, img.height);
      canvas.width = size;
      canvas.height = size;
      ctx.clearRect(0, 0, size, size);
      ctx.drawImage(
        img,
        (size - img.width) / 2,
        (size - img.height) / 2,
        img.width,
        img.height,
      );
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas produced no image"));
          return;
        }
        resolve(URL.createObjectURL(blob));
      }, "image/png");
    };
    img.onerror = () => reject(new Error("Image could not be decoded"));
    img.src = imageUrl;
  });
}
